import { render, staticRenderFns } from "./mBoldTable.vue?vue&type=template&id=9374d40c&scoped=true"
import script from "./mBoldTable.vue?vue&type=script&lang=js"
export * from "./mBoldTable.vue?vue&type=script&lang=js"
import style0 from "./mBoldTable.vue?vue&type=style&index=0&id=9374d40c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9374d40c",
  null
  
)

export default component.exports